export class RestoreAccountCloudAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsRestoreAccountAttributes",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpRestoreAccountAttributes",
            "format": ""
        },
        {
            "name": "azure",
            "baseName": "azure",
            "type": "AzureRestoreAccountAttributes",
            "format": ""
        },
        {
            "name": "mongoAtlas",
            "baseName": "mongoAtlas",
            "type": "MongoAtlasRestoreAccountAttributes",
            "format": ""
        },
        {
            "name": "googleWorkspace",
            "baseName": "googleWorkspace",
            "type": "GoogleWorkspaceRestoreAccountAttributes",
            "format": ""
        },
        {
            "name": "microsoft365",
            "baseName": "microsoft365",
            "type": "Microsoft365RestoreAccountAttributes",
            "format": ""
        },
        {
            "name": "entraId",
            "baseName": "entraId",
            "type": "EntraIdRestoreAccountAttributes",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAccountCloudAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
